export default __webpack_public_path__ + "static/tools-accessories-9174e12ed792a070190726c2dc7c47e3.jpg";